import { render, staticRenderFns } from "./Vacaciones.vue?vue&type=template&id=977cb7e6&scoped=true"
import script from "./Vacaciones.vue?vue&type=script&lang=js"
export * from "./Vacaciones.vue?vue&type=script&lang=js"
import style0 from "./Vacaciones.vue?vue&type=style&index=0&id=977cb7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977cb7e6",
  null
  
)

export default component.exports